export default __webpack_public_path__ + "static/media/NavdishaBanner.4768b0ad.svg";